import { Injectable } from '@angular/core';
import { DeliveryItems } from '@epicuro-next/state/config-strip-state';
import { Product, ScaleSets } from 'graphql-api/gql-api-interfaces';
import { BehaviorSubject } from 'rxjs';
import { CellData } from '../models/cell-data.type';
import { getMaterialsMatrix } from './process-materials';

interface State {
  materialsMatrix: Map<string, [CellData[]]>;
  ySizes: string[];
  xSizes: string[];
}

@Injectable()
export class MatrixService {
  private state: BehaviorSubject<State> = new BehaviorSubject<State>({
    materialsMatrix: new Map<string, [CellData[]]>(),
    ySizes: [],
    xSizes: [],
  });

  public processMaterials(
    availableScaleSets: ScaleSets,
    materials: Product[],
    deliveryItems: DeliveryItems,
    differentMaterialDimensions: boolean,
  ) {
    this.patchState({
      materialsMatrix: getMaterialsMatrix(
        availableScaleSets,
        materials,
        deliveryItems,
        differentMaterialDimensions,
      ),
    });
  }

  public get xSizes() {
    return this.getProperty('xSizes') as string[];
  }

  public get ySizes() {
    return this.getProperty('ySizes') as string[];
  }

  public get materialsMatrix() {
    return this.getProperty('materialsMatrix') as Map<string, [CellData[]]>;
  }

  private getProperty(property: keyof State) {
    const state = this.get();
    return state[property];
  }

  public selectScale(scale: string, availableScaleSets: ScaleSets) {
    const activeScale = availableScaleSets.scales[scale];
    // For Bras it might be band / cup, for shoes might be size / width, for jeans size / length.
    // There's currently no way to figure out which one is the main dimension.
    const [xDimension, yDimension] = Object.keys(activeScale);

    this.patchState({
      xSizes: activeScale[xDimension],
      ySizes: activeScale[yDimension],
    });
  }

  private patchState(newState: Partial<State>) {
    this.state.next({
      ...this.state.value,
      ...newState,
    });
  }

  private get() {
    return this.state.value;
  }
}
